<div class="content-wrapper">

  <section class="content-header">
    <h1>
      Notícias
      <small>Criar, listar e editar</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/home">
          <i class="fa fa-home"></i> Home</a>
      </li>
      <li class="active">Notícias</li>
    </ol>
  </section>

  <br>

  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">Gerenciar conteúdo</h3>
      </div>

      <br>

      <div class="box-body no-padding">

        <div class="col-md-7">
          <form autocomplete="off">
            <div class="input-group input-group-sm">
              <input type="text" class="form-control" name="titulo" placeholder="Pesquisar por título">
              <span class="input-group-btn">
                <button type="submit" class="btn btn-primary ">
                  <i class="fa fa-search"></i>
                </button>
              </span>
            </div>

                      <div class="form-group col-sm-12 no-padding" style="margin-top: 8px;">
                <label class="checkbox-inline">
                    <input type="checkbox" [(ngModel)]="manterFiltrosSelecionados" name="manterFiltrosSelecionados"
                        (ngModelChange)="alterarManterFiltrosSelecionados($event)">
                    Manter filtros selecionados
                </label>
            </div></form>
        </div>

        <div class="col-md-5">
          <button routerLink="/noticias/nova" type="button" class="btn pull-right btn-primary ">
            Nova notícia</button>
        </div>

        <div class="col-md-12">
          <hr>
        </div>

        <div class="col-md-12">
          <!-- <p-dataTable [value]="dados" [responsive]="true" emptyMessage="Nenhum registro encontrado." [paginator]="filtro"
            [rows]="8" [lazy]="true" [totalRecords]="totalRegistros" #tabela>

            <p-column field="titulo" header="Título"></p-column>
            <p-column field="para" header="Para:"></p-column>
            <p-column field="statusEdital" header="Status"></p-column>
            <p-column styleClass="col-acoes" header="Ações">
              <ng-template let-edit="rowData" pTemplate="body"></ng-template>
            </p-column>

          </p-dataTable> -->
        </div>

      </div>

      <br>
      <div class="box-footer clearfix"></div>

    </div>

  </div>